import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'dum-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.scss'],
})
export class UsuariosComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
